import * as React from 'react';
import styled from 'styled-components';
import { IProfileResult } from '../../../../data/providers/reports/profileReportProvider';
import { Entity } from '../../../../data/types';
import { Row } from '../../../layout/Row';
import { EPdfMode } from '../../../shared/pdf/Pdf';
import { ProfileResult } from './ProfileResult';

interface IProps {
  results: IProfileResult[];
  pdfMode: EPdfMode;
  entity: Entity;
}
export const ResultList = (props: IProps): React.ReactElement => {
  return (
    <Row>
      <Container>
        {props.results.map(
          (result: IProfileResult, index: number): React.ReactElement => {
            return (
              <ProfileResult
                result={result}
                key={index}
                pdfMode={props.pdfMode}
                entity={props.entity}
              />
            );
          }
        )}
      </Container>
    </Row>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--grid-gap);
`;
